<template>
  <div class="row">
    <div class="leftCard">
      <slot name="image"></slot>
    </div>
    <div class="rightCard">
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

.row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.leftCard, .rightCard {
  background: bisque;
  height: 70vh;
}

.leftCard {
  width: 55%;
  display: flex;
  align-items: center;
}

.rightCard {
  width: 45%;
  display: table;
}

@media (max-width: 1000px) {
  .row {
    flex-direction: column;
  }
  .leftCard, .rightCard {
    width: 100%;
    height: 70%;
  }
}
</style>